import React from "react";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../utils/routes";
import arrowRight from "../../assets/icons/common/arrowRight.svg";
const Breadcrumbs = () => {
  const location = useLocation();
  const breadcrumbs = [];

  // Iterate through the route configuration to find matching routes
  routes.forEach((route) => {
    if (location.pathname.startsWith(route.path)) {
      breadcrumbs.push({
        label: route.label,
        url: route.path,
      });
    }
  });

  return (
    <div className="flex px-[4px] lg:px-[16px] py-[8px] lg:hidden ">
      {breadcrumbs.map((breadcrumb, index) => (
        <span key={index} className="flex  items-center text-[#334155] text-[12px]">
          <Link to={breadcrumb.url} className="px-[3px]">{breadcrumb.label}</Link>
          {index < breadcrumbs.length - 1 && <img src={arrowRight} alt="" />}
        </span>
      ))}
    </div>
  );
};

export default Breadcrumbs;
